import React, { useState } from 'react';
import { usePopper } from 'react-popper';
import { Tip, Triangle, Wrap } from './styled';
import { IConfig, Sides } from '../types';
import { Placement, TooltipPopoverProps } from './types';
import { theme } from '../../../theme';
import { Text } from '../../Text';

const defaultConfig: IConfig = {
  side: Sides.TOP,
  triangleOffset: 6,
  tipMinWidth: 60,
  tipMaxWidth: 340,
};

export const TooltipPopover = ({
  content,
  text,
  hoverableElement,
  config,
  reversed,
  withTriangle,
  classNames,
}: TooltipPopoverProps) => {
  const [popperElement, setPopperElement] = useState<HTMLDivElement | null>(null);

  const usedConfig = { ...defaultConfig, ...config };
  const { side, triangleOffset, tipMinWidth, tipMaxWidth } = usedConfig;

  const { styles, attributes } = usePopper(hoverableElement, popperElement, {
    placement: `${side}-${reversed ? 'end' : 'start'}` as Placement,
    modifiers: [
      {
        name: 'offset',
        options: {
          offset: [0, 8],
        },
      },
    ],
  });

  const tooltipStyles = {
    ...styles.popper,
    zIndex: theme.layers.tooltip,
  };

  return (
    <Tip
      key="tooltip-tip"
      className={classNames.tip}
      ref={setPopperElement}
      triangleOffsetSize={triangleOffset}
      style={tooltipStyles}
      {...attributes.popper}
      role="tooltip"
    >
      <Wrap className={classNames.wrap} tipMinWidth={tipMinWidth} tipMaxWidth={tipMaxWidth}>
        {content ?? (
          <Text variant="bodySmall" style={{ color: 'white' }}>
            {text}
          </Text>
        )}
      </Wrap>
      {withTriangle && <Triangle id="veeqo-components-triangle" className={classNames.triangle} />}
    </Tip>
  );
};
